import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App';
import { AuthProvider } from './auth';
import { ToastProvider } from './components/toast';
import { ApiError } from './api/client';

import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Bei einer abgelaufenen Sitzung waere jeder Wiederholungsversuch
      // vergeblich - die Oberflaeche soll dann sofort die Anmeldemaske
      // zeigen statt dreimal in denselben Fehler zu laufen.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403)) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
